module.exports = __webpack_public_path__ + "static/media/Cuentas.56d3db22.svg";